import { useEffect, useState } from 'react';

import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { userApis } from '../../../apis/userApis';
import AlertMessage from '../../../components/elements/alert-message/AlertMessage';
import Loading from '../../../components/elements/loading/Loading';
import Breadcrumbs from '../../../components/sections/breadcrumbs/Breadcrumbs';
import List from '../../../components/sections/list/List';
import TitlePanel from '../../../components/sections/title-panel/TitlePanel';
import { useUser } from '../../../contexts/UserContext';
import { handleErrors } from '../../../helpers';
import useToast from '../../../hooks/useToast';
import { PRIVATE_ROUTE } from '../../../routes/routes';
import { sentenceCase } from '../../../utils/utils';

const ProjectsPage = () => {
  const { t } = useTranslation();

  const [projects, setProjects] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const navigate = useNavigate();
  const { user } = useUser();
  const { showToast } = useToast();

  useEffect(() => {
    if (!user) return;

    const fetchData = async () => {
      try {
        const { data } = await userApis.getUserProjects(user.id);
        const projects = data.content.map((item) => ({
          ...item,
          role: user.getRole(item.id),
        }));

        setProjects(projects);
      } catch (error) {
        handleErrors(navigate, error, showToast);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    if (user) fetchData();
  }, [user]);

  const renderNewProject = () => navigate(PRIVATE_ROUTE.PROJECT_NEW);

  return (
    <Container>
      {loading ? (
        <Loading />
      ) : error ? (
        <AlertMessage
          severity="error"
          message={sentenceCase(
            t('loading', {
              ns: 'errors',
              content: t('projects', { ns: 'titles' }),
            })
          )}
        />
      ) : (
        <>
          <Breadcrumbs />
          <TitlePanel visible title={t('projects', { ns: 'titles' })}>
            <Button onClick={renderNewProject}>
              {t('createProject', { ns: 'buttons' })}
            </Button>
          </TitlePanel>
          <List isProjectList data={projects} />
        </>
      )}
    </Container>
  );
};

export default ProjectsPage;
